export default __webpack_public_path__ + "static/media/delievered.b8ca14c2.gif";